// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: left;
  width: 90%;
  max-width: 950px;
  margin: 0 auto;
  color: #000000;
  font-family: Arial;
  display: block;
  line-height: 1.5rem;
}

#alphaliner-title {
  font-size: 30px;
}

#login-button-div {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

#login-button {
  background-color: #3c80d8;
  color: white;
  padding: 10px 10px;
  margin: 80px auto;
  border: none;
  cursor: pointer;
  width: 180px;
  height: 40px;
  border-radius: 5px;
}

.user-screen {
  max-width: 850px;
  margin: 0 auto;
  width: 100%;
}

.selection-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 90%;
  margin: 2% auto;
}

.selection-column {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.selection-column.right {
  align-items: flex-end;
}

.dropdown-wrapper {
  display: inline-block;
}

.dropdown-wrapper select {
  width: auto;
  min-width: 120px;
}

.nav-links {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-end;
}

.nav-link {
  background: none;
  border: none;
  color: #00008B;
  cursor: pointer;
  font-size: 16px;
  text-align: right;
  padding: 0;
  margin: 0;
  line-height: 1.8;
}

.nav-link:hover {
  text-decoration: underline;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-card {
  background: #fff;
  border-radius: 12px;
  width: min(500px, 92vw);
  box-shadow: 0 18px 70px rgba(0,0,0,0.25);
  padding: 16px;
  overflow: hidden;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 16px;
  border-bottom: 1px solid #eee;
  position: relative;
}

.modal-header h2 {
  margin: 0;
  text-align: center;
  line-height: 1.2;
}

.modal-body {
  padding: 16px;
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 auto;
}

.modal-row {
  display: grid;
  grid-template-columns: 110px 1fr;
  gap: 12px;
  align-items: center;
  margin-bottom: 12px;
}

.modal-row input[type="number"] {
  width: 140px;
}

.modal-hint {
  margin-top: 8px;
  font-size: 13px;
  opacity: 0.85;
}

.modal-footer {
  padding: 12px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-top: 1px solid #eee;
}

.admin-container {
  width: 100%;
  margin: 0 auto;
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: visible;
  overflow-y: visible;
}

.admin-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.admin-section {
  margin-top: 24px;
  width: 100%;
}

.admin-button {
  background-color: #3c80d8;
  color: white;
  border: none;
  padding: 6px 10px;
  cursor: pointer;
  border-radius: 4px;
  height: 30px;
  width: 150px;
}

.admin-button-secondary {
  background-color: #3db432;
  color: white;
  border: none;
  padding: 6px 10px;
  cursor: pointer;
  border-radius: 4px;
  height: 30px;
  width: 100px;
}

.admin-button-danger {
  background-color: #d83c3c;
  color: white;
  border: none;
  padding: 6px 10px;
  cursor: pointer;
  border-radius: 4px;
  height: 30px;
  width: 100px;
}

.admin-table {
  width: 100%;
  margin-top: 8px;
  border-collapse: collapse;
}

.admin-table th {
  text-align: left;
  padding: 6px;
  font-weight: bold;
}

.admin-table td {
  padding: 6px;
}

.admin-input {
  width: 150px;
  padding: 4px 6px;
  font-family: Arial;
  font-size: 14px;
  box-sizing: border-box;
}

.admin-actions {
  display: flex;
  gap: 6px;
}

.admin-warning {
  color: red;
  padding: 10px;
  margin: 10px 0;
  font-weight: 500;
}

.newsletter-qna-screen {
  width: 100%;
  margin: 0 auto 50px auto;
  padding-top: 20px;
}

.newsletter-qna-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.newsletter-qna-description {
  font-size: 18px;
  margin: 0 0 16px;
}

.newsletter-qna-description ul {
  font-size: 18px;
}

.newsletter-qna-description li {
  margin: 2px;
}

.newsletter-qna-card {
  border: 1px solid #d8d8e8;
  border-radius: 8px;
  padding: 16px;
  background: #fafaff;
}

.newsletter-qna-controls {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
  margin-bottom: 12px;
}

.newsletter-qna-range {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.newsletter-qna-selectors {
  display: flex;
  gap: 8px;
}

.newsletter-qna-selectors select,
.newsletter-qna-selectors input,
.newsletter-qna-input {
  padding: 6px 8px;
  font-size: 14px;
  border: 1px solid #c8c8d8;
  border-radius: 4px;
}

.newsletter-qna-selectors input {
  width: 90px;
}

.newsletter-qna-label {
  font-weight: 600;
}

.newsletter-qna-input {
  width: 100%;
  box-sizing: border-box;
  resize: vertical;
  min-height: 100px;
}

.newsletter-qna-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}

.newsletter-qna-answer {
  margin-top: 16px;
  padding: 16px;
}

.newsletter-qna-answer ul,
.newsletter-qna-answer ol {
  font-size: 18px;
  padding: 5px;
}

.newsletter-qna-error {
  margin-top: 12px;
  color: #b00020;
  font-weight: 600;
}

.newsletter-qna-placeholder {
  color: #666;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #000000;
  color: #FFFFFF;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: left;
  font-size: calc(10px + 2vmin);
}

.App-link {
  color: #00008B;
}

h1, h3 {
  text-align: left;
  color: #00008B;
  line-height: 1.2;
}

h2 {
  text-align: left;
  line-height: 1.25;
}

#login-header {
  text-align: center;
  margin-top: 50px;
}

p, ul {
  color: #000000;
  font-size: 120%;
}

li {
  margin-bottom: 2%;
}

.customer-header {
  text-align: left;
}

/* Responsive styles for smaller devices */
@media (max-width: 768px) {
  .App {
    width: 95%;
    font-size: 1rem;
  }

  #login-button {
    width: 100%;
    max-width: 300px;
    margin: 20px auto;
    display: block;
  }

  #open-pdf-button {
    width: 98%;
    max-width: 180px;
    margin: 20px auto;
    display: block;
  }

  .selection-row {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }

  .selection-column {
    width: 100%;
    align-items: center;
  }

  .selection-column.right {
    align-items: center;
  }

  .nav-links {
    align-items: center;
  }

  .nav-link {
    text-align: center;
  }

  h1, h3 {
    text-align: center;
    line-height: 1.2;
  }

  h2 {
    text-align: left;
    line-height: 1.25;
  }

  p, ul {
    font-size: 1.1rem;
  }
}

@media (max-width: 480px) {
  .App {
    width: 95%;
    font-size: 1rem;
  }

  #alphaliner-title {
    font-size: 25px;
  }

  #login-button, #open-pdf-button {
    width: 100%;
    max-width: 180px;
    padding: 8px;
  }

  .selection-menu {
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin-left: 0;
  }

  h1, h3 {
    text-align: center;
    line-height: 1.2;
  }

  h2 {
    text-align: left;
    line-height: 1.25;
  }

  p, ul {
    font-size: 1.1rem;
    line-height: 1.7rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAkB;EAAlB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;;EAGE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;;EAEE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF","sourcesContent":[".App {\n  text-align: left;\n  width: 90%;\n  max-width: 950px;\n  margin: 0 auto;\n  color: #000000;\n  font-family: Arial;\n  display: block;\n  line-height: 1.5rem;\n}\n\n#alphaliner-title {\n  font-size: 30px;\n}\n\n#login-button-div {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n#login-button {\n  background-color: #3c80d8;\n  color: white;\n  padding: 10px 10px;\n  margin: 80px auto;\n  border: none;\n  cursor: pointer;\n  width: 180px;\n  height: 40px;\n  border-radius: 5px;\n}\n\n.user-screen {\n  max-width: 850px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.selection-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  width: 90%;\n  margin: 2% auto;\n}\n\n.selection-column {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.selection-column.right {\n  align-items: flex-end;\n}\n\n.dropdown-wrapper {\n  display: inline-block;\n}\n\n.dropdown-wrapper select {\n  width: auto;\n  min-width: 120px;\n}\n\n.nav-links {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  align-items: flex-end;\n}\n\n.nav-link {\n  background: none;\n  border: none;\n  color: #00008B;\n  cursor: pointer;\n  font-size: 16px;\n  text-align: right;\n  padding: 0;\n  margin: 0;\n  line-height: 1.8;\n}\n\n.nav-link:hover {\n  text-decoration: underline;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.modal-card {\n  background: #fff;\n  border-radius: 12px;\n  width: min(500px, 92vw);\n  box-shadow: 0 18px 70px rgba(0,0,0,0.25);\n  padding: 16px;\n  overflow: hidden;\n}\n\n.modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 14px 16px;\n  border-bottom: 1px solid #eee;\n  position: relative;\n}\n\n.modal-header h2 {\n  margin: 0;\n  text-align: center;\n  line-height: 1.2;\n}\n\n.modal-body {\n  padding: 16px;\n  width: fit-content;\n  margin: 0 auto;\n}\n\n.modal-row {\n  display: grid;\n  grid-template-columns: 110px 1fr;\n  gap: 12px;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.modal-row input[type=\"number\"] {\n  width: 140px;\n}\n\n.modal-hint {\n  margin-top: 8px;\n  font-size: 13px;\n  opacity: 0.85;\n}\n\n.modal-footer {\n  padding: 12px 16px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-top: 1px solid #eee;\n}\n\n.admin-container {\n  width: 100%;\n  margin: 0 auto;\n  padding-top: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  overflow-x: visible;\n  overflow-y: visible;\n}\n\n.admin-header {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.admin-section {\n  margin-top: 24px;\n  width: 100%;\n}\n\n.admin-button {\n  background-color: #3c80d8;\n  color: white;\n  border: none;\n  padding: 6px 10px;\n  cursor: pointer;\n  border-radius: 4px;\n  height: 30px;\n  width: 150px;\n}\n\n.admin-button-secondary {\n  background-color: #3db432;\n  color: white;\n  border: none;\n  padding: 6px 10px;\n  cursor: pointer;\n  border-radius: 4px;\n  height: 30px;\n  width: 100px;\n}\n\n.admin-button-danger {\n  background-color: #d83c3c;\n  color: white;\n  border: none;\n  padding: 6px 10px;\n  cursor: pointer;\n  border-radius: 4px;\n  height: 30px;\n  width: 100px;\n}\n\n.admin-table {\n  width: 100%;\n  margin-top: 8px;\n  border-collapse: collapse;\n}\n\n.admin-table th {\n  text-align: left;\n  padding: 6px;\n  font-weight: bold;\n}\n\n.admin-table td {\n  padding: 6px;\n}\n\n.admin-input {\n  width: 150px;\n  padding: 4px 6px;\n  font-family: Arial;\n  font-size: 14px;\n  box-sizing: border-box;\n}\n\n.admin-actions {\n  display: flex;\n  gap: 6px;\n}\n\n.admin-warning {\n  color: red;\n  padding: 10px;\n  margin: 10px 0;\n  font-weight: 500;\n}\n\n.newsletter-qna-screen {\n  width: 100%;\n  margin: 0 auto 50px auto;\n  padding-top: 20px;\n}\n\n.newsletter-qna-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.newsletter-qna-description {\n  font-size: 18px;\n  margin: 0 0 16px;\n}\n\n.newsletter-qna-description ul {\n  font-size: 18px;\n}\n\n.newsletter-qna-description li {\n  margin: 2px;\n}\n\n.newsletter-qna-card {\n  border: 1px solid #d8d8e8;\n  border-radius: 8px;\n  padding: 16px;\n  background: #fafaff;\n}\n\n.newsletter-qna-controls {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.newsletter-qna-range {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.newsletter-qna-selectors {\n  display: flex;\n  gap: 8px;\n}\n\n.newsletter-qna-selectors select,\n.newsletter-qna-selectors input,\n.newsletter-qna-input {\n  padding: 6px 8px;\n  font-size: 14px;\n  border: 1px solid #c8c8d8;\n  border-radius: 4px;\n}\n\n.newsletter-qna-selectors input {\n  width: 90px;\n}\n\n.newsletter-qna-label {\n  font-weight: 600;\n}\n\n.newsletter-qna-input {\n  width: 100%;\n  box-sizing: border-box;\n  resize: vertical;\n  min-height: 100px;\n}\n\n.newsletter-qna-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 12px;\n}\n\n.newsletter-qna-answer {\n  margin-top: 16px;\n  padding: 16px;\n}\n\n.newsletter-qna-answer ul,\n.newsletter-qna-answer ol {\n  font-size: 18px;\n  padding: 5px;\n}\n\n.newsletter-qna-error {\n  margin-top: 12px;\n  color: #b00020;\n  font-weight: 600;\n}\n\n.newsletter-qna-placeholder {\n  color: #666;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #000000;\n  color: #FFFFFF;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: left;\n  justify-content: left;\n  font-size: calc(10px + 2vmin);\n}\n\n.App-link {\n  color: #00008B;\n}\n\nh1, h3 {\n  text-align: left;\n  color: #00008B;\n  line-height: 1.2;\n}\n\nh2 {\n  text-align: left;\n  line-height: 1.25;\n}\n\n#login-header {\n  text-align: center;\n  margin-top: 50px;\n}\n\np, ul {\n  color: #000000;\n  font-size: 120%;\n}\n\nli {\n  margin-bottom: 2%;\n}\n\n.customer-header {\n  text-align: left;\n}\n\n/* Responsive styles for smaller devices */\n@media (max-width: 768px) {\n  .App {\n    width: 95%;\n    font-size: 1rem;\n  }\n\n  #login-button {\n    width: 100%;\n    max-width: 300px;\n    margin: 20px auto;\n    display: block;\n  }\n\n  #open-pdf-button {\n    width: 98%;\n    max-width: 180px;\n    margin: 20px auto;\n    display: block;\n  }\n\n  .selection-row {\n    flex-direction: column;\n    align-items: center;\n    gap: 20px;\n  }\n\n  .selection-column {\n    width: 100%;\n    align-items: center;\n  }\n\n  .selection-column.right {\n    align-items: center;\n  }\n\n  .nav-links {\n    align-items: center;\n  }\n\n  .nav-link {\n    text-align: center;\n  }\n\n  h1, h3 {\n    text-align: center;\n    line-height: 1.2;\n  }\n\n  h2 {\n    text-align: left;\n    line-height: 1.25;\n  }\n\n  p, ul {\n    font-size: 1.1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .App {\n    width: 95%;\n    font-size: 1rem;\n  }\n\n  #alphaliner-title {\n    font-size: 25px;\n  }\n\n  #login-button, #open-pdf-button {\n    width: 100%;\n    max-width: 180px;\n    padding: 8px;\n  }\n\n  .selection-menu {\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    margin-left: 0;\n  }\n\n  h1, h3 {\n    text-align: center;\n    line-height: 1.2;\n  }\n\n  h2 {\n    text-align: left;\n    line-height: 1.25;\n  }\n\n  p, ul {\n    font-size: 1.1rem;\n    line-height: 1.7rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
